import React from 'react';

import EmptyState from '../common/EmptyState';
import { CARD_ICON, COMPASS, PLUS } from '../icons';
import { canManage } from '../../utils/permissions';
import { newCardPath } from '../../config/collectionShell';

// The copy lives here once, so the items list and the collection's home can
// never drift apart. KPE-009: Zach approves the wording in review.
export const NO_CARDS_COPY = {
	managerTitle: 'Start with a card',
	readerTitle: 'No cards yet',
	whatACardIs: 'A card describes one kind of record, like a book or a vehicle inspection, and the elements each one holds.',
	managerNext: 'Create one, or start from a ready-made card in Discover.',
	readerNote: 'Ask the collection’s manager to add one.',
};

/**
 * A collection with no cards, where its items would be (KPR-322). The
 * caller decides WHEN — truly empty, nothing filtering — and this decides
 * WHAT, by whether the person can change the collection's cards.
 *
 * A manager gets the two doors to a first card: Create a card opens the
 * Card Library's own new-card flow for this collection (the card belongs to
 * it), and Browse Discover is where ready-made cards and card bundles are
 * cloned in. Anyone else gets the same explanation and who to ask, with no
 * buttons: the server would refuse both (render-honesty only — it re-checks).
 */
export default function NoCardsEmptyState({ collection, collectionId, className = '' }) {
	const manager = canManage(collection) && Boolean(collectionId);
	return manager ? (
		<EmptyState
			className={className}
			data-testid="no-cards-empty-state"
			icon={<CARD_ICON />}
			title={NO_CARDS_COPY.managerTitle}
			description={[NO_CARDS_COPY.whatACardIs, NO_CARDS_COPY.managerNext]}
			primaryAction={{ label: 'Create a card', icon: <PLUS />, to: newCardPath(collectionId) }}
			secondaryAction={{ label: 'Browse Discover', icon: <COMPASS />, to: '/discover' }}
			learnMore="cards-and-elements/create-a-card"
		/>
	) : (
		<EmptyState
			className={className}
			data-testid="no-cards-empty-state"
			icon={<CARD_ICON />}
			title={NO_CARDS_COPY.readerTitle}
			description={NO_CARDS_COPY.whatACardIs}
			note={NO_CARDS_COPY.readerNote}
			learnMore="cards-and-elements"
		/>
	);
}
